import { render, staticRenderFns } from "./form_input.vue?vue&type=template&id=2b22327a&"
import script from "./form_input.vue?vue&type=script&lang=js&"
export * from "./form_input.vue?vue&type=script&lang=js&"
import style0 from "./form_input.vue?vue&type=style&index=0&id=2b22327a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports